/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventupdatedbutsomeimagesfailedtoupload7Inputs */

const en_eventupdatedbutsomeimagesfailedtoupload7 = /** @type {(inputs: Eventupdatedbutsomeimagesfailedtoupload7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event updated, but some images failed to upload`)
};

const de_eventupdatedbutsomeimagesfailedtoupload7 = /** @type {(inputs: Eventupdatedbutsomeimagesfailedtoupload7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Event wurde aktualisiert, aber einige Bilder konnten nicht hochgeladen werden.`)
};

/**
* | output |
* | --- |
* | "Event updated, but some images failed to upload" |
*
* @param {Eventupdatedbutsomeimagesfailedtoupload7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventupdatedbutsomeimagesfailedtoupload7 = /** @type {((inputs?: Eventupdatedbutsomeimagesfailedtoupload7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventupdatedbutsomeimagesfailedtoupload7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventupdatedbutsomeimagesfailedtoupload7(inputs)
	return de_eventupdatedbutsomeimagesfailedtoupload7(inputs)
});
export { eventupdatedbutsomeimagesfailedtoupload7 as "eventUpdatedButSomeImagesFailedToUpload" }